module.exports = __webpack_public_path__ + "media/images/talent/img-conversion-6f23a698325cb4f663e8e1303fe252c9.png";